import { Bar } from "vue-chartjs";
import { currentSavingsGraphOptions } from "./currentSavingsGraphOptions.js";
import { createNamespacedHelpers } from "vuex";
import { formatNumberWithComma } from "@/utils";
import moment from "moment";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	{ mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	extends: Bar,

	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	data() {
		return { datasets: null };
	},

	computed: {
		...userGetters(["weightUnitMinor", "weightFactorMinor"]),
		...brandingGetters(["colors"]),
	},

	mounted() {
		this.init();
	},

	methods: {
		init,
		chartData,
		getChartLabels,
		getChartYAxisLabel,
	},
};

function init() {
	const data = this.chartData();

	this.renderChart(data, currentSavingsGraphOptions({ getChartYAxisLabel: this.getChartYAxisLabel }));
}

function chartData() {
	const performance = [],
		goal = [],
		// eslint-disable-next-line max-len
		baseline = this.data.baseline.wpg * this.weightFactorMinor,
		_self = this;

	this.data.months.forEach((month) => {
		performance.push(month.wpg * this.weightFactorMinor);
		goal.push(baseline * (1 - month.savings_goal));
	});

	// set performace / goal first element as empty (baseline)
	performance.unshift(baseline);
	goal.unshift(null);

	this.datasets = [
		{
			barThickness: 30,
			maxBarThickness: 24,
			label: this.$t("tracked_items.your_performance"),
			backgroundColor(context) {
				// color the first item - baseline or first month - differently
				return context.dataIndex === 0 ? _self.colors[4] : _self.colors[3];
			},
			data: performance,
		},
		{
			barThickness: 30,
			maxBarThickness: 24,
			label: this.$t("tracked_items.monthly_savings_goal"),
			backgroundColor: this.colors[1],
			data: goal,
		},
	];

	return {
		labels: this.getChartLabels(),
		datasets: this.datasets,
	};
}

function getChartLabels() {
	const months = [];
	months.push(this.$t("global.baseline"));
	this.data.months.forEach((month) => {
		months.push(moment(month.month, "YYYY/MM").format("MMM YYYY"));
	});
	return months;
}

function getChartYAxisLabel(value) {
	return `${formatNumberWithComma(value)} ${this.weightUnitMinor}`;
}
